var map = {
	"./music-instructions.json": 4832,
	"./music-library-intro2024.json": 4833,
	"./music-library-launch2024.json": 4834,
	"./music-progression.json": 4835,
	"./startSourcesAdvanced.json": 4836,
	"./startSourcesSimple.json": 4837,
	"./startSourcesSimple2.json": 4838,
	"./startSourcesTracks.json": 4839
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4526;